module.exports = __webpack_public_path__ + "static/img/service1.f62f597.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kfc/service1.jpg
// module id = EweT
// module chunks = 0